import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Field,
  reduxForm,
  reset,
  submit,
  stopSubmit,
  setSubmitFailed,
} from "redux-form";
import _ from "lodash";
import { IMAGE_PATH, itemCount, COMMON_FAIL_MESSAGE } from "Constants";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import FormBuilder from "../../../tickets/components/form-builder/form-builder";
import { showError, showSuccess } from "ReduxErrorBar";
import { saveForm, updateFomeName, updateFormList } from "FormBuilderAction";
import {
  addProposal,
  fetchProposalStep,
  updateProposal,
  editProposal,
  fetchSingleProposal,
} from "ProposalAction";
import LocaleStrings from "Languages";

class PropFormBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  componentDidMount() {
    //console.log("this.props.initialValues", this.props.initialValues);
    if (
      this.props.initialValues &&
      this.props.initialValues.proposalid &&
      this.props.initialValues.event_forms_by_formid &&
      this.props.initialValues.event_forms_by_formid.formname
    ) {
      let formname = this.props.initialValues.event_forms_by_formid.formname;
      var newObj = JSON.parse(
        this.props.initialValues.event_forms_by_formid.formjson
      );
      this.props.updateFomeName(formname); // Form Name
      this.props.updateFormList(newObj, this.props.oldKeys, "samearray");
    } else {
      let defaultOptions = [
        {
          key: "label",
          required: true,
          maxlen: 250,
          label: "Enter your title",
          name: "faqtitle",
          id: "faqtitle",
        },
        {
          key: "paragraph",
          required: true,
          maxlen: 1000,
          label: "Enter your description",
          name: "faqdesc",
          id: "faqdesc",
        },
      ];

      var newObj = [
        {
          key: "group",
          type: "abstract",
          name: "abstract",
          defaultfields: true,
          isactive: true,
          required: false,
          maxentries: 2,
          label: "newText",
          header: "Group Data",
          taborder: 1,
          id: "abstract",
          groupfields: defaultOptions,
        },
        {
          key: "textinput",
          defaultfields: "fixed",
          required: false,
          maxlen: "250",
          label: "Email",
          name: "email",
          id: "email",
          header: "Input",
        },
        {
          key: "textinput",
          defaultfields: "fixed",
          required: false,
          maxlen: "250",
          label: "First Name",
          name: "firstname",
          id: "firstname",
          header: "Input",
        },
        {
          key: "textinput",
          defaultfields: "fixed",
          required: false,
          maxlen: "250",
          label: "Last Name",
          name: "lastname",
          id: "lastname",
          header: "Input",
        },
        {
          key: "textarea",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "2000",
          label: "Bio",
          name: "biography",
          id: "biography",
          header: "Textarea",
          taborder: 2,
          reviewerVisible: false,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Company",
          name: "company",
          id: "company",
          header: "Input",
          taborder: 2,
          reviewerVisible: false,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Designation",
          name: "designation",
          id: "designation",
          header: "Input",
          taborder: 2,
          reviewerVisible: false,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Phone Number",
          name: "phonenumber",
          id: "phonenumber",
          header: "Input",
          taborder: 2,
          reviewerVisible: false,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Facebook",
          name: "facebook",
          id: "facebook",
          header: "Input",
          taborder: 2,
          reviewerVisible: false,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Twitter",
          name: "twitter",
          id: "twitter",
          header: "Input",
          taborder: 2,
          reviewerVisible: false,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Linkedin",
          name: "linkedin",
          id: "linkedin",
          header: "Input",
          taborder: 2,
          reviewerVisible: false,
        },
        //{key:'singlecheckbox',defaultfields:true,isactive: true,required:false,label:'Networking/GDPR Consent (This will enable you to share your profile and connect with other users.)',name:'isnetworking',id:'isnetworking',header:'Checkbox',taborder:1,reviewerVisible:false},
        {
          key: "singlecheckbox",
          defaultfields: true,
          isactive: true,
          required: false,
          label: "Terms & Conditions",
          name: "termsconditions",
          id: "termsconditions",
          header: "Checkbox",
          taborder: 2,
          reviewerVisible: false,
        },
      ];
      this.props.updateFomeName("Proposal Form");
      this.props.updateFormList(newObj, [], "new");
    }
  }

  componentWillReceiveProps(nextProps) {}

  onSubmitForm = (values) => {
    if (
      values.proposalid &&
      values.event_forms_by_formid &&
      values.event_forms_by_formid.formid
    ) {
      var { oldKeys, editMode, formName } = this.props;

      var formid = values.event_forms_by_formid.formid;
      var formName = formName;
      var formnumber = values.event_forms_by_formid.formnumber;
      let version = values.event_forms_by_formid.versionno;
      var newVersion = parseInt(version) + 1;

      // Rearrange the taborder if any field is removed or added
      var newArrAvailable = [];
      oldKeys.map((value, index) => {
        newArrAvailable.push({ ...value, taborder: index + 1 });
      });
      var oldKeys = newArrAvailable;

      let unique = [...new Set(oldKeys.map((a) => a.label))]; // Check unique field

      let name_email = _.filter(oldKeys, (obj) => {
        return (
          obj.label.toLowerCase() == "first name" ||
          obj.label.toLowerCase() == "last name" ||
          obj.label.toLowerCase() == "email"
        );
      }); // Checking if name or email exist or not

      // if (name_email.length > 0) {
      //   this.props.showError(
      //     LocaleStrings.dynamic_form_validation_name_email_field_not_required
      //   );
      // } else {
      var formvalues = {
        formid: formid,
        formname: formName,
        formnumber: formnumber,
        versionno: newVersion,
        formtype: "proposal",
        formjson: JSON.stringify(oldKeys),
        ispublished: values.event_forms_by_formid.ispublished,
        ismandatory: values.event_forms_by_formid.ismandatory,
      };

      this.setState({ loading: true });
      this.props.saveForm(this.props.session, formvalues, (response) => {
        if (response.success === 0) {
          this.setState({ loading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          let newformid = response.data.newformid;

          if (newformid) {
            let data = {};

            data.formid = newformid;
            data.proposalid = values.proposalid;
            data.proposal_name = values.proposal_name;
            data.proposaldesc = values.proposaldesc;
            data.category = values.category;

            this.props.updateProposal(this.props.session, data, (response) => {
              if (response.success === 0) {
                this.setState({ loading: false });
                this.props.showError(COMMON_FAIL_MESSAGE);
              } else {
                this.props.fetchSingleProposal(
                  this.props.session,
                  values.proposalid,
                  (response) => {
                    let proposalList = response.data;
                    this.props.editProposal(proposalList[0]);
                  }
                );

                this.setState({ loading: false });
                this.props.showSuccess(
                  LocaleStrings.proposal_form_updated_success
                );
                this.props.fetchProposalStep("step_3");
              }
            });
          }
        }
      });
      //}
    } else {
      var { oldKeys, formName, initialValues } = this.props;
      var p = "0123456789";
      var formnumber = [...Array(6)].reduce(
        (a) => a + p[~~(Math.random() * p.length)],
        ""
      );
      var version = 1;
      var formid = "";
      var formtype = "proposal";

      let unique = [...new Set(oldKeys.map((a) => a.label))]; // Check unique field
      let name_email = _.filter(oldKeys, (obj) => {
        return (
          obj.label.toLowerCase() == "name" ||
          obj.label.toLowerCase() == "last name" ||
          obj.label.toLowerCase() == "email"
        );
      }); // Checking if name or email exist or not

      // if (name_email.length > 0) {
      //   this.props.showError(
      //     LocaleStrings.dynamic_form_validation_name_email_field_not_required
      //   );
      // } else

      // if (unique.length != oldKeys.length) {
      //   this.props.showError(
      //     LocaleStrings.dynamic_form_validation_all_field_should_unique
      //   );
      // } else {
      var formvalues = {
        formid: formid,
        formname: formName,
        formnumber: formnumber,
        versionno: version,
        formtype: formtype,
        formjson: JSON.stringify(oldKeys),
        ispublished: 1,
        ismandatory: 0,
      };

      this.setState({ loading: true });
      this.props.saveForm(this.props.session, formvalues, (response) => {
        if (response.success === 0) {
          this.setState({ loading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          let formid = response.data.newformid;
          if (formid) {
            let data = {};
            data.proposalid = values.proposalid;
            data.formid = formid;

            this.props.updateProposal(this.props.session, data, (response) => {
              if (response.success === 0) {
                this.setState({ loading: false });
                this.props.showError(COMMON_FAIL_MESSAGE);
              } else {
                // this.props.checkProposalFormStatus(this.props.session);
                // this.setState({ loading: false });
                // this.props.showSuccess(
                //   LocaleStrings.dynamic_form_created_success
                // );
                // this.props.fetchProposalStep("step_3");

                this.props.fetchSingleProposal(
                  this.props.session,
                  values.proposalid,
                  (response) => {
                    let proposalList = response.data;
                    this.props.editProposal(proposalList[0]);
                  }
                );

                this.setState({ loading: false });
                this.props.showSuccess(
                  LocaleStrings.proposal_form_updated_success
                );
                this.props.fetchProposalStep("step_3");
              }
            });
          }
        }
      });
      //}
    }
  };

  onSubmitForm1 = (values) => {
    if (values.event_forms_by_formid && values.event_forms_by_formid.formid) {
      var { oldKeys, editMode, formName, checkProposalForm } = this.props;

      var formid = values.event_forms_by_formid.formid;
      var formName = formName;
      var formnumber = values.event_forms_by_formid.formnumber;
      let version = values.event_forms_by_formid.versionno;
      var newVersion = parseInt(version) + 1;

      // Rearrange the taborder if any field is removed or added
      var newArrAvailable = [];
      oldKeys.map((value, index) => {
        newArrAvailable.push({ ...value, taborder: index + 1 });
      });
      var oldKeys = newArrAvailable;

      let unique = [...new Set(oldKeys.map((a) => a.label))]; // Check unique field

      let name_email = _.filter(oldKeys, (obj) => {
        return (
          obj.label.toLowerCase() == "first name" ||
          obj.label.toLowerCase() == "last name" ||
          obj.label.toLowerCase() == "email"
        );
      }); // Checking if name or email exist or not

      if (name_email.length > 0) {
        this.props.showError(
          LocaleStrings.dynamic_form_validation_name_email_field_not_required
        );
      } else if (unique.length != oldKeys.length) {
        this.props.showError(
          LocaleStrings.dynamic_form_validation_all_field_should_unique
        );
      } else {
        var formvalues = {
          formid: formid,
          formname: formName,
          formnumber: formnumber,
          versionno: newVersion,
          formtype: "proposal",
          formjson: JSON.stringify(oldKeys),
          ispublished: values.event_forms_by_formid.ispublished,
          ismandatory: values.event_forms_by_formid.ismandatory,
        };

        this.setState({ loading: true });
        this.props.saveForm(this.props.session, formvalues, (response) => {
          if (response.success === 0) {
            this.setState({ loading: false });
            this.props.showError(COMMON_FAIL_MESSAGE);
          } else {
            let newformid = response.data.newformid;

            if (newformid) {
              values.formid = newformid;
              values.proposalid = values.proposalid;
              //console.log('values',values);
              this.props.updateProposal(
                this.props.session,
                values,
                (response) => {
                  if (response.success === 0) {
                    this.setState({ loading: false });
                    this.props.showError(COMMON_FAIL_MESSAGE);
                  } else {
                    this.props.checkProposalFormStatus(this.props.session);

                    this.setState({ loading: false });
                    this.props.showSuccess(
                      LocaleStrings.proposal_form_updated_success
                    );
                    this.props.fetchProposalStep("step_3");
                  }
                }
              );
            }
          }
        });
      }
    } else {
      var { oldKeys, formName, initialValues } = this.props;
      var p = "0123456789";
      var formnumber = [...Array(6)].reduce(
        (a) => a + p[~~(Math.random() * p.length)],
        ""
      );
      var version = 1;
      var formid = "";
      var formtype = "proposal";

      let unique = [...new Set(oldKeys.map((a) => a.label))]; // Check unique field
      let name_email = _.filter(oldKeys, (obj) => {
        return (
          obj.label.toLowerCase() == "name" ||
          obj.label.toLowerCase() == "last name" ||
          obj.label.toLowerCase() == "email"
        );
      }); // Checking if name or email exist or not

      if (name_email.length > 0) {
        this.props.showError(
          LocaleStrings.dynamic_form_validation_name_email_field_not_required
        );
      } else if (unique.length != oldKeys.length) {
        this.props.showError(
          LocaleStrings.dynamic_form_validation_all_field_should_unique
        );
      } else {
        var formvalues = {
          formid: formid,
          formname: formName,
          formnumber: formnumber,
          versionno: version,
          formtype: formtype,
          formjson: JSON.stringify(oldKeys),
          ispublished: 1,
          ismandatory: 0,
        };

        this.setState({ loading: true });
        this.props.saveForm(this.props.session, formvalues, (response) => {
          if (response.success === 0) {
            this.setState({ loading: false });
            this.props.showError(COMMON_FAIL_MESSAGE);
          } else {
            let formid = response.data.newformid;
            if (formid) {
              values.formid = formid;
              this.props.addProposal(this.props.session, values, (response) => {
                if (response.success === 0) {
                  this.setState({ loading: false });
                  this.props.showError(COMMON_FAIL_MESSAGE);
                } else {
                  this.props.checkProposalFormStatus(this.props.session);
                  this.setState({ loading: false });
                  this.props.showSuccess(
                    LocaleStrings.dynamic_form_created_success
                  );
                  this.props.fetchProposalStep("step_3");
                }
              });
            }
          }
        });
      }
    }
  };

  renderCustomTextarea(field) {
    var divClassName = `row form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    return (
      <div className={divClassName}>
        <label className="control-label-top col-sm-12 m-0 mb-5">
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>{" "}
          <span style={{ fontSize: 10 }}>
            (
            {
              LocaleStrings.tickets_ticket_form_label_ticket_description_extra_text
            }
            )
          </span>
        </label>
        <div className="col-sm-12 col-sm-offset-0">
          <textarea
            className="form-control"
            placeholder={field.placeholder}
            maxLength={field.maxLength}
            {...field.input}
            disabled={field.disabled}
            style={{ height: 75 }}
          ></textarea>
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderFieldText(field) {
    var divClassName = `row form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label-top col-sm-12 m-0 mb-5";
    var inputClasses = "col-sm-12 col-sm-offset-0";

    return (
      <div className={divClassName}>
        <label className={labelClasses}>
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>
        <div className={inputClasses}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
            disabled={field.disabled}
            min={field.min ? field.min : ""}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      oldKeys,
      checkProposalForm,
      initialValues,
      updateProposal,
      editMode,
    } = this.props;
    //console.log('initialValues',initialValues);
    //console.log('editMode',editMode);

    var formtype = "proposal";
    var formBuilder = { category: formtype, fixedFields: null };

    return (
      <div className="scrollable-modal">
        <form onSubmit={handleSubmit(this.onSubmitForm)}>
          <div
            className="col-md-8 mb-15"
            style={{ marginLeft: "-15px", fontWeight: "bold" }}
          >
            {/* *You must need to publish once after updating the data */}
          </div>
          <FormBuilder source="proposal" formBuilderData={formBuilder} />

          <Button
            className="btn btn-custom-blue mt-10"
            bsStyle=""
            loading={this.state.loading}
            disabled={initialValues ? false : pristine || invalid || submitting}
            type="submit"
          >
            {LocaleStrings.proposal_form_button_save}
          </Button>
        </form>
      </div>
    );
  }
}

function mapStateToProps(state) {
  // console.log('formName :: == ', state.formName);
  //console.log('oldKeys :: == ', state.formList);
  var initVals = {};
  if (state.updateProposal && state.updateProposal.proposalid) {
    initVals = state.updateProposal ? state.updateProposal : {};
  }

  return {
    session: state.session,
    oldKeys: state.formList,
    formName: state.formName,
    initialValues: initVals,
    updateProposal: state.updateProposal,
    editMode: !_.isEmpty(state.updateProposal),
  };
}

function validate(values) {
  // console.log('values',values);
  var errors = {};

  return errors;
}

export default connect(mapStateToProps, {
  saveForm,
  updateFomeName,
  updateFormList,
  showError,
  showSuccess,
  addProposal,
  fetchProposalStep,
  updateProposal,
  editProposal,
  fetchSingleProposal,
})(
  reduxForm({
    validate,
    form: "ProposalFormBuilder",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(PropFormBuilder)
);
